<template>
    <div :id="`segmentExceptionColumn${name}${adUnit}${placementId}`" class="wrapper">
        <div class="data-col" :class="{ inactive: readOnly }">
            <slot></slot>
        </div>
        <div class="buttons-col" v-if="!readOnly">
            <button class="icon-button" v-if="showEdit" @click.stop="$emit('edit')">
                <IconBase
                    :iconColor="consts.COLORS.DARK_300"
                    :iconHoverColor="consts.COLORS.PRIMARY_500"
                    iconName="editIcon"
                    width="15"
                    height="13"
                />
            </button>
            <a href="#" class="add-btn" v-else @click.prevent="$emit('add')">
                + Add
            </a>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'BaseTableColumn',
    components: { IconBase },
    props: {
        showEdit: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        name: String,
        adUnit: String,
        placementId: [String, Number]
    },
    computed: {
        consts: () => consts
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
@import "~styles/buttons.scss";

.inactive {
    color: $light-800;
}

.wrapper {
    display: flex;

   .data-col {
       flex: 1;
       align-self: center;
    }

    .buttons-col {
        display: flex;
        align-items: center;

        .add-btn {
            margin-right: 7px;
        }
    }
}
</style>
